module.exports = __webpack_public_path__ + "media/99_点検者アカウント作成方法.d0b19185.mp4";